/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, inject } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { tap, catchError, EMPTY, finalize } from 'rxjs';
import { AuthService } from '../../../../services/auth.service';
import { SnackBarService } from '../../../../services/snack-bar.service';

@Component({
  selector: 'app-session-expired-dialog',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    TranslateModule,
    MatIconModule,
    MatProgressSpinnerModule,
  ],
  templateUrl: './session-expired-dialog.component.html',
  styleUrl: './session-expired-dialog.component.scss'
})
export class SessionExpiredDialogComponent {
  private authService = inject(AuthService);
  private snackBarService = inject(SnackBarService);
  private translateService = inject(TranslateService);
  private router = inject(Router);
  private dialogRef = inject(MatDialogRef<SessionExpiredDialogComponent>);

  isLoading = false;
  hide = true;

  loginForm: FormGroup = new FormGroup({
    username: new FormControl('', [Validators.required]),
    password: new FormControl('', [Validators.required]),
  });

  onLogin() {
    if (!this.loginForm.valid) return;

    this.isLoading = true;
    this.authService
      .login(this.loginForm.value)
      .pipe(
        tap((res: any) => {
          sessionStorage.setItem('token', res.access_token);
          sessionStorage.setItem('id', res.id);
          sessionStorage.setItem('username', res.userName);
          sessionStorage.setItem('profiloId', res.profiloId);
          sessionStorage.setItem('ruoloUtente', res.ruoloUtente);
          sessionStorage.setItem('denominazione', res.denominazione);

          this.dialogRef.close(true);

          window.location.reload();
        }),
        catchError((err) => {
          this.snackBarService.errorSnackBar(
            err.error.error_description ||  this.translateService.instant("soa.loginFailed"),
            this.translateService.instant("openSnackBar.close")
          );
          return EMPTY;
        }),
        finalize(() => (this.isLoading = false))
      )
      .subscribe();
  }

  onExit() {
    this.dialogRef.close(false);
    this.router.navigate(['/login']);
  }
}
